<div class="space-y-6">
  <div class="prose">
    <h1>
      {{ 'pages.unauthorized.title' | translate }}
    </h1>
    <h2>
      {{ 'pages.unauthorized.subtitle' | translate }}
    </h2>
  </div>

  <div class="text-center">
    <svg-icon
      src="assets/icons/Security/lock-01.svg"
      class="size-96 text-grey-300"
    />
  </div>

  <p class="text-base/relaxed text-grey-600">
    {{ 'pages.unauthorized.message' | translate }}
  </p>

  <div class="flex max-w-screen-xl gap-6">
    <app-button data-test-id="backButton" class="" type="outline" (trigger)="navigateToHome()">
      {{ 'pages.unauthorized.backButton' | translate }}
    </app-button>
  </div>
</div>
